export default __webpack_public_path__ + "media/images/icon_public-2d798a39bb2bd6314e47b00669686556.png";